import './App.css';

import { Login } from "./components/Login";
import { ThemeProvider, defaultTheme } from '@aws-amplify/ui-react';

export default function App() {
  return (
    <ThemeProvider theme={defaultTheme}>
      <Login />
    </ThemeProvider>
  );
};
